
const pageAccordion = $('.pageAccordion');
const targetAccodion = $('.targetAccordion');

pageAccordion.on('click', function() {
  $(this).next().slideToggle(1500);

});